import React, { useState, useEffect, useContext } from 'react'

import { useJwt } from 'react-jwt'
import UserContext from '../contexts/UserContext'
import { UserProviderProps } from '../types/globalTypes'

const PrivateRoute: React.FC<UserProviderProps> = (props) => {
  const { token } = useContext(UserContext)
  const { isExpired, decodedToken } = useJwt(token)
  const [statusValidate, setStatusValidate] = useState<boolean>(false)

  useEffect(() => {
    validateAccess()
  }, [statusValidate])

  const validateAccess = () => {
    if (isExpired) {
      window.location.href = '/'
    } else {
      setStatusValidate(true)
    }
  }

  return <>{statusValidate ? props.children : <></>}</>
}

export default PrivateRoute
